import React from 'react';
import ReactTooltip from 'react-tooltip';
import "../../styles/search/view_profile.css";
import { Link, useNavigate } from "react-router-dom";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc, getDocs, onSnapshot, updateDoc } from "firebase/firestore";
import { useSearchContext } from "../chats/searchContext";
import { getItem } from "../repositories/movies_and_tvseries";
import { useEffect, useRef, useState } from "react";

import fromImage from "../../images/authentication/no_profile.png";
import messageIcon from "../../images/profile/message_icon.png";
import emptyCollectionImage from "../../images/collections/empty_collection.png";

const ViewProfile = () => {
    const goTo = useNavigate();
    const followersRef = useRef(null);
    const followingRef = useRef(null);
    const collectionsRef = useRef(null);
    const {getUserId, setUserId} = useSearchContext();
    const [getCollectionNum, setCollectionNum] = useState(0);
    const [getYourUserId, setYourUserId] = useState("");
    const [getUserFullName, setUserFullName] = useState("");
    const [getUserName, setUserName] = useState("");
    const [getUserBio, setUserBio] = useState("");
    const [getUserImage, setUserImage] = useState("");
    const [getUserBackdropImage, setUserBackdropImage] = useState("");
    const [getActiveTab, setActiveTab] = useState("collections");
    const [getCollectionsError, setCollectionsError] = useState("");
    const [getFollowersError, setFollowersError] = useState("");
    const [getFollowingError, setFollowingError] = useState("");
    const [getFollowersList, setFollowersList] = useState([]);
    const [getFollowingList, setFollowingList] = useState([]);
    const [getCollectionsList, setCollectionsList] = useState([]);
    const [getIsFollowersLoading, setIsFollowersLoading] = useState(true);
    const [getIsFollowingLoading, setIsFollowingLoading] = useState(true);
    const [getIsCollectionsLoading, setIsCollectionsLoading] = useState(true);
    const [getIsFollowing, setIsFollowing] = useState(false);

    const onSelectOption = (option) => {
        setActiveTab(option);
    }

    const onView = (personId) => {
        if (personId !== getYourUserId) {
            setUserFullName("");
            setUserName("");
            setUserImage("");
            setUserBackdropImage("");
            setUserBio("");
            setCollectionsList([]);
            setFollowingList([]);
            setFollowersList([]);
            setIsFollowersLoading(true);
            setIsFollowingLoading(true);
            setUserId(personId);
        }
    }

    const onFollow = async () => {
        try {
            const userRef = doc(firebaseFirestore, 'User Details', getYourUserId); 
            const userDoc = await getDoc(userRef);
            if (userDoc.exists()) {
                let followingMap = userDoc.data()["following"] || [];
                if (getIsFollowing) {
                    followingMap = followingMap.filter(id => id !== getUserId);
                } else{
                    followingMap.push(getUserId);
                }
    
                await updateDoc(userRef, { following: followingMap }, { merge: true }).then(() => {
                    setIsFollowing(!getIsFollowing);
                });
            }
        } catch (error) {
            console.log(`Error getting this user's details: ${error.message}`);
        }
    
        try {
            const userRef = doc(firebaseFirestore, 'User Details', getUserId); 
            const userDoc = await getDoc(userRef);
            if (userDoc.exists()) {
                let followersMap = userDoc.data()["followers"] || [];
                if (getIsFollowing) {
                    followersMap = followersMap.filter(id => id !== getYourUserId);
                } else {
                    followersMap.push(getYourUserId);
                }
    
                await updateDoc(userRef, { followers: followersMap }, { merge: true }).then(() => {
                    setIsFollowing(!getIsFollowing);
                });
            }
        }catch (error) {
            console.log(`Error getting this user's details: ${error.message}`);
        }
    };

    const getCardSpace = () => {
        if (getCollectionsList.length > 0 && getActiveTab === "collections" && getIsCollectionsLoading == false) {
            const parent = document.getElementById('view_profile_screen_available_grid');
            const parentWidth = parent.offsetWidth;
            const childWidth = window.innerWidth <= 600 ? 110 : 150 + 30;
            const numChildren = Math.floor(parentWidth / childWidth);
            parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
        }
    };

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace();
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getCollectionsList, getActiveTab]);

    useEffect(() => {
        const retrieveData = async () => {
            setFollowersError("");
            setFollowingError("");
            try {
                const userRef = doc(firebaseFirestore, 'User Details', getUserId); 
                const allUsersRef = collection(firebaseFirestore, 'User Details'); 
                const allUsersSnapshot = await getDocs(allUsersRef);

                const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
                    if (docSnapshot.exists()) {
                        const userData = docSnapshot.data();
                        Object.keys(userData).forEach((fieldName) => {
                            if (fieldName.startsWith("following")) {
                                let list = [];
                                const followingListA = userData[fieldName];
                                if (followingListA.includes(getUserId)) {
                                    setIsFollowing(true);
                                }else{
                                    setIsFollowing(false);
                                }

                                allUsersSnapshot.forEach((userDoc) => {
                                    if (followingListA.includes(userDoc.id)) {
                                        const details = {
                                            id: userDoc.id,
                                            username: userDoc.data().username,
                                            image: userDoc.data().image,
                                        };

                                        list.push(details);
                                    };
                                });

                                setFollowingList(list);
                            };

                            if (fieldName.startsWith("followers")) {
                                let list = [];
                                const followersListA = userData[fieldName];
                                allUsersSnapshot.forEach((userDoc) => {
                                    if (followersListA.includes(userDoc.id)) {
                                        const details = {
                                            id: userDoc.id,
                                            username: userDoc.data().username,
                                            image: userDoc.data().image,
                                        };

                                        list.push(details);
                                    };
                                });
                                setFollowersList(list);
                            };

                            if (fieldName.startsWith("fullname")) {
                                const fullNameListA = userData[fieldName];
                                setUserFullName(fullNameListA);
                            };

                            if (fieldName.startsWith("username")) {
                                const usernameListA = userData[fieldName];
                                setUserName(usernameListA);
                            };

                            if (fieldName.startsWith("image")) {
                                const imageListA = userData[fieldName];
                                setUserImage(imageListA);
                            };

                            if (fieldName.startsWith("backdrop_image")) {
                                const backdropImageListA = userData[fieldName];
                                setUserBackdropImage(backdropImageListA);
                            };

                            if (fieldName.startsWith("bio")) {
                                const bioListA = userData[fieldName];
                                setUserBio(bioListA);
                            };
                        });
                    };
                });

                setIsFollowersLoading(false);
                setIsFollowingLoading(false);
                setIsCollectionsLoading(false);
            
                return () => unsubscribe
            } catch (error) {
                console.log(`Error ${error}`);
                setIsFollowersLoading(false);
                setIsFollowingLoading(false);
                setIsCollectionsLoading(false);
                setFollowersError("Error");
                setFollowingError("Error");
                setCollectionsError("Error");
            }
        };

        retrieveData();
    }, [getUserId]);

    useEffect(() => {
        let num = 0;
        getCollectionsList.map((collection) => {
            if (collection.privacy === "public") {
                num += 1;
            };
        });

        setCollectionNum(num);
    }, [getCollectionsList]);

    useEffect(() => {
        try {
            const userRef = doc(firebaseFirestore, 'User Details', getYourUserId); 
            const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const userData = docSnapshot.data();
                    Object.keys(userData).forEach((fieldName) => {
                        if (fieldName.startsWith("following")) {
                            const followingListA = userData[fieldName];
                            if (followingListA.includes(getUserId)) {
                                setIsFollowing(true);
                            }else{
                                setIsFollowing(false);
                            }
                        };
                    });
                };
            });
        
            return () => unsubscribe
        } catch (error) {
            console.log(`Error ${error}`);
        }
    }, [getYourUserId]);

    useEffect(() => {
        try {
            const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const collectionsData = docSnapshot.data();
                    let collectionsArray = [];
                    Object.keys(collectionsData).forEach((fieldName) => {
                        if (fieldName.startsWith("collection")) {
                            const collection = collectionsData[fieldName];
                            collection.id = fieldName;
                            collectionsArray.push({ ...collection });
                        }
                    });

                    const updatedCollections = await Promise.all(
                        collectionsArray.map(async (collection) => {
                            if (collection.items && collection.items.length > 0) {
                                const itemId = collection.items[0].split("_")[1];
                                const type = collection.items[0].split("_")[0];
                                const details = await getItem({ itemId, type: type === "movie" ? type : "tv" });
                                return { ...collection, image: details.poster_path };
                            }
                            return { ...collection, image: "" };
                        })
                    );

                    const sortedCollections = updatedCollections.sort((a, b) => {
                        if (a.name && b.name) {
                            return a.name.localeCompare(b.name);
                        }
                        return 0;
                    });

                    sortedCollections.map((collection) => {
                        if (collection.privacy.toLowerCase() === "private") {
                            sortedCollections.splice(sortedCollections.indexOf(collection), 1);
                        };
                    });

                    setCollectionsList(sortedCollections);
                }
            });

            return () => scription;
        } catch (error) {
            console.log(error);
        }
    }, [getUserId]);

    useEffect(() => {
        if (getUserId === "" || getUserId === null) {
            goTo("/main_back/search", {replace: true});
        }
    }, [getUserId]);

    useEffect(() => {
        document.getElementById("view_profile_screen_header_container_backdrop").style.backgroundImage = `url(${getUserBackdropImage == null || getUserBackdropImage === "" ? null : getUserBackdropImage})`
    }, [getUserBackdropImage]);

    useEffect(() => {
        if (getActiveTab === "followers") {
            followersRef.current.classList.add("active");
            followingRef.current.classList.remove("active");
            collectionsRef.current.classList.remove("active");
        } else if (getActiveTab === "following") {
            followersRef.current.classList.remove("active");
            followingRef.current.classList.add("active");
            collectionsRef.current.classList.remove("active");
        } else {
            followersRef.current.classList.remove("active");
            followingRef.current.classList.remove("active");
            collectionsRef.current.classList.add("active");
        }
    }, [getActiveTab]);

    useEffect (() => {
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
          if (user) {
            setYourUserId(user.uid);
          }
        });
    
        return () => isLoggedIn();
    }, []);

    return(
        <div className="view_profile_screen">
            <div className="view_profile_screen_header_container">
                <div id="view_profile_screen_header_container_backdrop" className="view_profile_screen_header_container_backdrop"></div>
                <div className="view_profile_screen_header_container_overlay"></div>
                <div className="view_profile_screen_header_container_content">
                    <img alt='profile' className="view_profile_screen_header_container_image" src={getUserImage === "" || getUserImage === null ? fromImage : getUserImage} />
                    <div className="view_profile_screen_header_container_content_column">
                        <p className="view_profile_screen_header_container_fullname">{getUserFullName === null ? "" : getUserFullName}</p>
                        <p className="view_profile_screen_header_container_username">{getUserName === "" || getUserName === null ? "Unable to retrieve username" : `@${getUserName}`}</p>
                        <p className="view_profile_screen_header_container_bio">{getUserBio === null ? "" : getUserBio}</p>
                        {/* <p className="profile_screen_header_container_bio">Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative  Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images </p> */}
                        <p className="view_profile_screen_header_container_follow" onClick={onFollow}>{getIsFollowing ? "following" : "follow"}</p>
                    </div>
                    <Link data-tip data-for="send_message" className="view_profile_screen_link" to={getUserId === "" || getUserId == null ? null : `/main_back/chats/${getUserName}`}><img alt='message' className="profile_screen_header_container_edit" src={messageIcon} /></Link>
                    <ReactTooltip effect='solid' id="send_message" place="top">Message</ReactTooltip>
                </div>
            </div>

            <div className="view_profile_screen_heads_row">
                <div id="view_profile_screen_heads_row_con_3" className="view_profile_screen_heads_row_con_3" ref={collectionsRef} onClick={() => onSelectOption("collections")}>
                    {/* <img src={collectionIcon} className="view_profile_screen_heads_row_con_image" /> */}
                    <p className="view_profile_screen_heads_row_con_text">{getCollectionNum.toString()}</p>
                    <p className="view_profile_screen_heads_row_con_text">{getCollectionNum === 1 ? "Collection" : "Collections"}</p>
                </div>
                <div id="view_profile_screen_heads_row_con" className="view_profile_screen_heads_row_con" ref={followersRef} onClick={() => onSelectOption("followers")}>
                    <p className="view_profile_screen_heads_row_con_text">{getFollowersList.length.toString()}</p>
                    <p className="view_profile_screen_heads_row_con_text">{getFollowersList.length === 1 ? "Follower" : "Followers"}</p>
                </div>
                <div id="view_profile_screen_heads_row_con_2" className="view_profile_screen_heads_row_con_2" ref={followingRef} onClick={() => onSelectOption("following")}>
                    <p className="view_profile_screen_heads_row_con_text">{getFollowingList.length.toString()}</p>
                    <p className="view_profile_screen_heads_row_con_text">Following</p>
                </div>
            </div>

            <div className='view_profile_screen_block_column'>
                {
                    getActiveTab === "followers"
                    ? <div className="view_profile_screen_followers_block">
                        {
                            getFollowersError === ""
                            ? getIsFollowersLoading
                                ? <p className="view_profile_screen_followers_block_error">Loading...</p>
                                : getFollowersList.length > 0
                                    ? getFollowersList.map((followers, index) => (
                                        <div key={index} className="search_screen_block_tab">
                                            <div className="search_screen_block_tab_con">
                                                <img alt='profile' className="search_screen_block_tab_image" src={followers.image === "" || followers.image == null ? fromImage : followers.image} />
                                                <p className="search_screen_block_tab_name">@{followers.username}</p>
                                            </div>
                
                                            <Link className="search_screen_link" 
                                                to={
                                                    followers.id === "" || followers.id === null 
                                                    ? null 
                                                    : followers.id !== getYourUserId
                                                    ? `/main_back/search/${followers.username.toLowerCase()}/profile`
                                                    : `/main_back/profile`
                                                }
                                            >
                                                <p className="search_screen_block_tab_view" onClick={() => onView(followers.id)}>view</p>
                                            </Link>                                        
                                        </div>
                                    ))
                                    : <p className="view_profile_screen_followers_block_error">@{getUserName} does not have any followers <span role='img' aria-label='neutral face.'>😐</span></p>

                            : <p className="view_profile_screen_followers_block_error">Unable to load @{getUserName}'s followers list <span role='img' aria-label='smiling face with tear'>🥲</span></p>
                        }
                    </div>
                    : null
                }

                {
                    getActiveTab === "following"
                    ? <div className="view_profile_screen_following_block">
                        {
                            getFollowingError === ""
                            ? getIsFollowingLoading
                                ? <p className="view_profile_screen_followers_block_error">Loading...</p>
                                : getFollowingList.length > 0
                                    ? getFollowingList.map((following, index) => (
                                        <div key={index} className="search_screen_block_tab">
                                            <div className="search_screen_block_tab_con">
                                                <img alt='profile' className="search_screen_block_tab_image" src={following.image === "" || following.image == null ? fromImage : following.image} />
                                                <p className="search_screen_block_tab_name">@{following.username}</p>
                                            </div>
                
                                            <Link className="search_screen_link" 
                                                to={
                                                    following.id === "" || following.id === null 
                                                    ? null 
                                                    : following.id !== getYourUserId
                                                    ? `/main_back/search/${following.username.toLowerCase()}/profile`
                                                    : `/main_back/profile`
                                                }
                                            >
                                                <p className="search_screen_block_tab_view" onClick={() => onView(following.id)}>view</p>
                                            </Link>                                        
                                        </div>
                                    ))
                                    : <p className="view_profile_screen_followers_block_error">@{getUserName} is not following anyone <span role='img' aria-label='neutral face.'>😐</span></p>

                            : <p className="view_profile_screen_followers_block_error">Unable to load @{getUserName}'s following list <span role='img' aria-label='smiling face with tear'>🥲</span></p>
                        }
                    </div>
                    :null
                }

                {
                    getActiveTab === "collections"
                    ? getCollectionsError === ""
                        ? getIsCollectionsLoading
                            ? <p className="view_profile_screen_followers_block_error">Loading...</p>
                            : <div className="profile_screen_following_block">
                                {
                                    getCollectionsList.length > 0
                                    ? <div id="view_profile_screen_available_grid" className="view_profile_screen_available_grid">
                                        {
                                            getCollectionsList.map((collection, index) => (
                                                collection.privacy === "public"
                                                ? <Link className="action_container_sub_home_screen_a" to={`/main_back/search/${getUserName.toLowerCase()}/collections/${collection.id}/${collection.name.toLowerCase()}`}><div key={index} id="movie_item" className="movie_item">
                                                    <img
                                                        src={collection.image === "" || collection.image === null ? emptyCollectionImage : `https://image.tmdb.org/t/p/w500${collection.image}`}
                                                        alt={collection.name}
                                                        className="movie_poster"
                                                    />
                                                    <p className="movie_item_p">{collection.name}</p>
                                                </div></Link>
                                                : null
                                            ))                        
                                        }
                                    </div>
                                    : <p style={{marginTop: "20px", textAlign: "center"}} classNmae="view_profile_screen_followers_block_error">@{getUserName} does not have any public collections <span role='img' aria-label='neutral face.'>😐</span></p>
                                }
                            </div>
                        : <p className="view_profile_screen_followers_block_error">Unable to retrieve @{getUserName} collections <span role='img' aria-label='smiling face with tear'>🥲</span></p>
                    : null
                }
            </div>
        </div>
    );
};

export default ViewProfile;